// @flow
// @jsx h
import { h } from "preact";
import {ThemeConfig} from "elc-theme"

// style
import styles from "./TabLabel.scss";

/**
 * Quantities tab component
 */
const TabLabel = (
  {
    theme,
    active,
    label
  }: {
    theme?: Object,
    active: boolean,
    label: string
  },
  context
) => (
  <ThemeConfig.Consumer>
  { themeConfig => {
     return(
          <div
            class={`${
              active
                ? theme && theme.labelActive
                  ? theme.labelActive
                  : styles.labelActive
                : theme && theme.labelInactive
                  ? theme.labelInactive
                  : styles.labelInactive
            } ${styles.label}`}
            style={`color:${
              themeConfig && themeConfig.color1 && active
                ? themeConfig.color1
                : ""
            };`}
          >
            {label}
          </div>
  		 )}
      }
    </ThemeConfig.Consumer>
);
export default TabLabel;
